import React from "react";
import MuiCircularProgress from "@mui/material/CircularProgress";
import MuiButton from "@mui/material/Button";
import MuiTextField from "@mui/material/TextField";
import MuiCheckbox from "@mui/material/Checkbox";
import MuiFormHelperText from "@mui/material/FormHelperText";

// Source
import * as HelperSrc from "../HelperSrc";
import ControllerLocalization from "../controller/Localization";
import ControllerUserProfile from "../controller/UserProfile";
import ViewLoader from "./Loader";

let isRendered = false;

const viewPageUserProfile: React.FC = () => {
    // Variable
    const controllerUserProfile = new ControllerUserProfile(isRendered);
    const controllerLocalization = new ControllerLocalization(isRendered);

    // Method
    controllerUserProfile.initializeHook();
    controllerLocalization.initializeHook();

    // Render
    isRendered = true;

    if (controllerLocalization.getStorageMain && controllerUserProfile.getValidationForm) {
        return (
            <div className="view_user_profile form" data-at_id="view_user_profile">
                {(() => {
                    const html: JSX.Element[] = [];

                    if (controllerUserProfile.getDataMain) {
                        html.push(
                            <div>
                                <div>
                                    {(() => {
                                        const html: JSX.Element[] = [];

                                        html.push(
                                            <div>
                                                <div className="field_container">
                                                    <MuiTextField
                                                        variant="outlined"
                                                        className="field_value disabled"
                                                        name="id"
                                                        label={controllerLocalization.getStorageMain.id}
                                                        defaultValue={controllerUserProfile.getDataMain.id || ""}
                                                        disabled
                                                    />
                                                    <MuiFormHelperText className="field_helper"></MuiFormHelperText>
                                                </div>
                                                <div className="field_container">
                                                    <MuiTextField
                                                        variant="outlined"
                                                        className="field_value disabled date"
                                                        name="last_activity"
                                                        label={controllerLocalization.getStorageMain.profile_last_activity}
                                                        value={
                                                            controllerUserProfile.getDataMain.last_activity
                                                                ? HelperSrc.localeFormat(new Date(controllerUserProfile.getDataMain.last_activity))
                                                                : ""
                                                        }
                                                        disabled
                                                    />
                                                    <MuiFormHelperText className="field_helper"></MuiFormHelperText>
                                                </div>
                                                <div className="field_container">
                                                    <MuiTextField
                                                        variant="outlined"
                                                        className="field_value disabled"
                                                        name="auth_type"
                                                        label={controllerLocalization.getStorageMain.profile_auth_type}
                                                        defaultValue={controllerUserProfile.getDataMain.auth_type || ""}
                                                        disabled
                                                    />
                                                    <MuiFormHelperText className="field_helper"></MuiFormHelperText>
                                                </div>
                                            </div>
                                        );

                                        return html;
                                    })()}
                                    <div className="field_container">
                                        <MuiTextField
                                            variant="outlined"
                                            className="field_value"
                                            data-at_id="input_username"
                                            name="username"
                                            label={controllerLocalization.getStorageMain.username}
                                            defaultValue={controllerUserProfile.getDataMain.username || ""}
                                            required={controllerUserProfile.getValidationForm.username.required}
                                            onChange={(event) => {
                                                if (controllerUserProfile.getValidationForm) {
                                                    HelperSrc.checkRegex(
                                                        event.target,
                                                        event.target.value,
                                                        controllerUserProfile.getValidationForm.username.regex_pattern,
                                                        controllerUserProfile.getValidationForm.username.error_msg
                                                    );
                                                }
                                            }}
                                        />
                                        <MuiFormHelperText className="field_helper"></MuiFormHelperText>
                                    </div>
                                    <div className="field_container">
                                        <MuiTextField
                                            variant="outlined"
                                            className="field_value"
                                            data-at_id="input_first_name"
                                            name="first_name"
                                            label={controllerLocalization.getStorageMain.first_name}
                                            defaultValue={controllerUserProfile.getDataMain.first_name || ""}
                                            required={controllerUserProfile.getValidationForm.first_name.required}
                                            onChange={(event) => {
                                                if (controllerUserProfile.getValidationForm) {
                                                    HelperSrc.checkRegex(
                                                        event.target,
                                                        event.target.value,
                                                        controllerUserProfile.getValidationForm.first_name.regex_pattern,
                                                        controllerUserProfile.getValidationForm.first_name.error_msg
                                                    );
                                                }
                                            }}
                                        />
                                        <MuiFormHelperText className="field_helper"></MuiFormHelperText>
                                    </div>
                                    <div className="field_container">
                                        <MuiTextField
                                            variant="outlined"
                                            className="field_value"
                                            data-at_id="input_last_name"
                                            name="last_name"
                                            label={controllerLocalization.getStorageMain.last_name}
                                            defaultValue={controllerUserProfile.getDataMain.last_name || ""}
                                            required={controllerUserProfile.getValidationForm.last_name.required}
                                            onChange={(event) => {
                                                if (controllerUserProfile.getValidationForm) {
                                                    HelperSrc.checkRegex(
                                                        event.target,
                                                        event.target.value,
                                                        controllerUserProfile.getValidationForm.last_name.regex_pattern,
                                                        controllerUserProfile.getValidationForm.last_name.error_msg
                                                    );
                                                }
                                            }}
                                        />
                                        <MuiFormHelperText className="field_helper"></MuiFormHelperText>
                                    </div>
                                    <div className="field_container">
                                        <MuiTextField
                                            variant="outlined"
                                            className="field_value"
                                            data-at_id="input_email"
                                            name="email"
                                            label={controllerLocalization.getStorageMain.email}
                                            defaultValue={controllerUserProfile.getDataMain.email || ""}
                                            required={controllerUserProfile.getValidationForm.email.required}
                                            onChange={(event) => {
                                                if (controllerUserProfile.getValidationForm) {
                                                    HelperSrc.checkRegex(
                                                        event.target,
                                                        event.target.value,
                                                        controllerUserProfile.getValidationForm.email.regex_pattern,
                                                        controllerUserProfile.getValidationForm.email.error_msg
                                                    );
                                                }
                                            }}
                                        />
                                        <MuiFormHelperText className="field_helper"></MuiFormHelperText>
                                    </div>
                                    <div className="field_container">
                                        <span className="checkbox_label">{controllerLocalization.getStorageMain.is_active}:</span>
                                        <MuiCheckbox
                                            className="field_value checkbox_style"
                                            data-at_id="input_is_active"
                                            name="is_active"
                                            defaultChecked={controllerUserProfile.getDataMain.is_active || false}
                                            required={controllerUserProfile.getValidationForm.is_active.required}
                                            onChange={(event) => {
                                                if (controllerUserProfile.getValidationForm) {
                                                    HelperSrc.checkRegex(
                                                        event.target,
                                                        event.target.value,
                                                        controllerUserProfile.getValidationForm.is_active.regex_pattern,
                                                        controllerUserProfile.getValidationForm.is_active.error_msg
                                                    );
                                                }
                                            }}
                                        />
                                        <MuiFormHelperText className="field_helper"></MuiFormHelperText>
                                    </div>
                                    <div className="field_container">
                                        <span className="checkbox_label">{controllerLocalization.getStorageMain.profile_is_checkbox_superuser}:</span>
                                        <MuiCheckbox
                                            className="field_value checkbox_style"
                                            data-at_id="input_is_checkbox_superuser"
                                            name="is_checkbox_superuser"
                                            defaultChecked={controllerUserProfile.getDataMain.is_checkbox_superuser || false}
                                            required={controllerUserProfile.getValidationForm.is_checkbox_superuser.required}
                                            onChange={(event) => {
                                                if (controllerUserProfile.getValidationForm) {
                                                    HelperSrc.checkRegex(
                                                        event.target,
                                                        event.target.value,
                                                        controllerUserProfile.getValidationForm.is_checkbox_superuser.regex_pattern,
                                                        controllerUserProfile.getValidationForm.is_checkbox_superuser.error_msg
                                                    );
                                                }
                                            }}
                                        />
                                        <MuiFormHelperText className="field_helper"></MuiFormHelperText>
                                    </div>
                                    <div className="field_container">
                                        <span className="checkbox_label">{controllerLocalization.getStorageMain.profile_is_checkbox_manager}:</span>
                                        <MuiCheckbox
                                            className="field_value checkbox_style"
                                            data-at_id="input_is_checkbox_manager"
                                            name="is_checkbox_manager"
                                            defaultChecked={controllerUserProfile.getDataMain.is_checkbox_manager || false}
                                            required={controllerUserProfile.getValidationForm.is_checkbox_manager.required}
                                            onChange={(event) => {
                                                if (controllerUserProfile.getValidationForm) {
                                                    HelperSrc.checkRegex(
                                                        event.target,
                                                        event.target.value,
                                                        controllerUserProfile.getValidationForm.is_checkbox_manager.regex_pattern,
                                                        controllerUserProfile.getValidationForm.is_checkbox_manager.error_msg
                                                    );
                                                }
                                            }}
                                        />
                                        <MuiFormHelperText className="field_helper"></MuiFormHelperText>
                                    </div>
                                    <div className="field_container">
                                        <span className="checkbox_label">{controllerLocalization.getStorageMain.profile_is_checkbox_staff}:</span>
                                        <MuiCheckbox
                                            className="field_value checkbox_style"
                                            data-at_id="input_is_checkbox_staff"
                                            name="is_checkbox_staff"
                                            defaultChecked={controllerUserProfile.getDataMain.is_checkbox_staff || false}
                                            required={controllerUserProfile.getValidationForm.is_checkbox_staff.required}
                                            onChange={(event) => {
                                                if (controllerUserProfile.getValidationForm) {
                                                    HelperSrc.checkRegex(
                                                        event.target,
                                                        event.target.value,
                                                        controllerUserProfile.getValidationForm.is_checkbox_staff.regex_pattern,
                                                        controllerUserProfile.getValidationForm.is_checkbox_staff.error_msg
                                                    );
                                                }
                                            }}
                                        />
                                        <MuiFormHelperText className="field_helper"></MuiFormHelperText>
                                    </div>
                                    <div className="field_container">
                                        <span className="checkbox_label">{controllerLocalization.getStorageMain.profile_is_checkbox_support}:</span>
                                        <MuiCheckbox
                                            className="field_value checkbox_style"
                                            data-at_id="input_is_checkbox_support"
                                            name="is_checkbox_support"
                                            defaultChecked={controllerUserProfile.getDataMain.is_checkbox_support || false}
                                            required={controllerUserProfile.getValidationForm.is_checkbox_support.required}
                                            onChange={(event) => {
                                                if (controllerUserProfile.getValidationForm) {
                                                    HelperSrc.checkRegex(
                                                        event.target,
                                                        event.target.value,
                                                        controllerUserProfile.getValidationForm.is_checkbox_support.regex_pattern,
                                                        controllerUserProfile.getValidationForm.is_checkbox_support.error_msg
                                                    );
                                                }
                                            }}
                                        />
                                        <MuiFormHelperText className="field_helper"></MuiFormHelperText>
                                    </div>
                                </div>
                                {(() => {
                                    const html: JSX.Element[] = [];

                                    if (HelperSrc.ENV_NAME === "local" || HelperSrc.ENV_NAME === "dev_jp" || HelperSrc.ENV_NAME === "dev_us") {
                                        html.push(
                                            <div>
                                                <div className="field_container">
                                                    <MuiTextField
                                                        type="password"
                                                        variant="outlined"
                                                        className="field_value"
                                                        data-at_id="input_password"
                                                        name="password"
                                                        label={controllerLocalization.getStorageMain.psw}
                                                        required={
                                                            controllerUserProfile.getDataMain
                                                                ? controllerUserProfile.getValidationForm.psw.required
                                                                : true
                                                        }
                                                        onChange={(event) => {
                                                            if (controllerUserProfile.getValidationForm) {
                                                                HelperSrc.checkRegex(
                                                                    event.target,
                                                                    event.target.value,
                                                                    controllerUserProfile.getValidationForm.psw.regex_pattern,
                                                                    controllerUserProfile.getValidationForm.psw.error_msg
                                                                );
                                                            }
                                                        }}
                                                    />
                                                    <MuiFormHelperText className="field_helper"></MuiFormHelperText>
                                                </div>
                                                <div className="field_container">
                                                    <MuiTextField
                                                        type="password"
                                                        variant="outlined"
                                                        className="field_value"
                                                        data-at_id="input_confirm_password"
                                                        name="confirm_password"
                                                        label={controllerLocalization.getStorageMain.profile_confirm_psw}
                                                        required={
                                                            controllerUserProfile.getDataMain
                                                                ? controllerUserProfile.getValidationForm.psw.required
                                                                : true
                                                        }
                                                        onChange={(event) => {
                                                            if (controllerUserProfile.getValidationForm) {
                                                                HelperSrc.checkRegex(
                                                                    event.target,
                                                                    event.target.value,
                                                                    controllerUserProfile.getValidationForm.psw.regex_pattern,
                                                                    controllerUserProfile.getValidationForm.psw.error_msg
                                                                );
                                                            }
                                                        }}
                                                    />
                                                    <MuiFormHelperText className="field_helper"></MuiFormHelperText>
                                                </div>
                                            </div>
                                        );
                                    }

                                    return html;
                                })()}
                                <div className="bottom">
                                    <div className="button_container">
                                        <MuiButton
                                            className="button_primary"
                                            data-at_id="button_update"
                                            disabled={controllerUserProfile.getApiLoadingList.profileChange}
                                            onClick={(event) => {
                                                controllerUserProfile.clickChange(event);
                                            }}
                                        >
                                            {(() => {
                                                const html: JSX.Element[] = [];

                                                if (controllerUserProfile.getApiLoadingList.profileChange) {
                                                    html.push(<MuiCircularProgress className="icon_progress" />);
                                                } else {
                                                    html.push(<>{controllerLocalization.getStorageMain.update}</>);
                                                }

                                                return html;
                                            })()}
                                        </MuiButton>
                                    </div>
                                </div>
                            </div>
                        );
                    }

                    return html;
                })()}
            </div>
        );
    } else {
        return <ViewLoader />;
    }
};

export default viewPageUserProfile;
